import React, { useState, useRef } from "react";
import { Button, TextField, Modal, Box, Typography } from "@mui/material";

function DeleteAccount() {
    const [email, setEmail] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [confirmModal, setConfirmModal] = useState(false);
    const emailRef = useRef();

    const handleDeleteAccount = () => {
        // Hesabı silme işlemi burada gerçekleştirilecek
        // Burada sadece modal'ı kapatıyoruz
        setTimeout(() => {
            setConfirmModal(false);
            setShowModal(true); // İşlem başarıyla gerçekleştirildiğinde göstermek için
            setEmail("");
        }, 2000);
    };

    return (
        <div className="flex justify-center items-center h-screen">
            <div className="text-center">
                <h1 className="text-3xl font-bold mb-8">Delete Your TenderTalk Account</h1>
                <div className="flex flex-col justify-center items-center">
                    <TextField
                        type="email"
                        label="E-mail Address"
                        variant="outlined"
                        style={{ width: 300 }}
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        inputRef={emailRef}
                    />
                    <Button
                        disabled={!email || email.length < 5 || !email.includes("@") || email === "" || email === ''}
                        variant="contained"
                        color="primary"
                        style={{ marginTop: 16 }}
                        onClick={() => setConfirmModal(true)}>
                        Delete Account
                    </Button>
                </div>
                <Modal open={showModal} onClose={() => setShowModal(false)}>
                    <Box
                        sx={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: 400,
                            bgcolor: "background.paper",
                            boxShadow: 24,
                            p: 4,
                        }}
                    >
                        <Typography variant="h6" gutterBottom>
                            Your account delete request has been successfully completed.
                        </Typography>
                        <Typography variant="h6" gutterBottom>
                            All your data delete in 14 days.
                        </Typography>
                        <Button onClick={() => setShowModal(false)}>Close</Button>
                    </Box>
                </Modal>
                <Modal open={confirmModal} onClose={() => setConfirmModal(false)}>
                    <Box
                        sx={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: 400,
                            bgcolor: "background.paper",
                            boxShadow: 24,
                            p: 4,
                        }}
                    >
                        <Typography variant="h6" gutterBottom>
                            Are you sure you want to delete your account?
                        </Typography>
                        <Typography style={{ marginTop: 10, marginBottom: 20 }} variant="h6" gutterBottom>
                            {emailRef.current?.value}
                        </Typography>
                        <Button
                            variant="contained"
                            color="error"
                            onClick={handleDeleteAccount}
                            className="mr-2">
                            Delete
                        </Button>
                        <Button
                            style={{ marginLeft: 10 }}
                            onClick={() => setConfirmModal(false)}>Cancel</Button>
                    </Box>
                </Modal>
            </div>
        </div>
    );
}

export default DeleteAccount;
